import { Controller } from "@hotwired/stimulus"
import { debounceAnimationFrame } from "../helpers"

export default class extends Controller {
  static targets = ["eyebrow", "title", "summary", "link"]

  initialize() {
    this.render = debounceAnimationFrame(this.render.bind(this))
  }

  render() {
    const label = this.field("label").value
    this.eyebrowTarget.textContent = `${label}:`
    this.eyebrowTarget.hidden = !label
    this.titleTarget.textContent = this.field("title").value
    this.summaryTarget.textContent = this.field("summary").value
    this.linkTarget.href = this.field("href").value
  }

  field(name) {
    return this.element.elements.namedItem(`announcement[${name}]`)
  }
}
